// utils/constants.js

// ============================================================================
// GraphQL Queries
// ============================================================================

export const GET_ALL_CATEGORIES_WITH_DETAILS = `
  query {
    categories {
      items {
        name
        nameAr
        description
      
        image {
          url
          alt
        }
        urlKey
        status
        products(filters: [
          {key: "limit", operation: eq, value: "80"},
        ]) {
          items {
            new_item {
              is_new_item
            }
            productId
            isSpicy
            name
            nameAr
            url
            price {
              regular {
                value
                text
              }
            } 
            image {
              alt
              origin
              thumb
              single
            } 
            description
            descriptionAr
            customizationGroups {
              customizationGroupId
              groupName
              groupDescription
              isRequired
              minSelections
              maxSelections
              displayOrder
              options {
                customizationOptionId
                optionName
                priceAddition
                displayOrder
                optionImage
              }
            }
          }
          total
        }
      }
    }
  }
`;

export const GET_ALL_COLLECTIONS = `
  query {
    collections {
      items {
        collectionId
        uuid
        name
        code
        products(filters: [
          {key: "limit", operation: eq, value: "80"}
        ]) {
          items {
            productId
            isSpicy
            name
            nameAr
            url
            urlKey
            price {
              regular {
                value
                text
              }
            }
            image {
              alt
              origin
              thumb
              single
            } 
            customizationGroups {
              customizationGroupId
              groupName
              groupDescription
              isRequired
              minSelections
              maxSelections
              displayOrder
              options {
                customizationOptionId
                optionName
                priceAddition
                displayOrder
                optionImage
              }
            }
            description
            descriptionAr
            new_item {
              is_new_item
            }
            category {
              name
              nameAr
            }
          }
        }
      }
    }
    setting {
      storeStatus
    }
  }
`;

// ============================================================================
// Category Configuration
// ============================================================================

export const CATEGORY_ORDER = [
  'Sandwiches',
  'Family Box',
  'Meals',
  'Kids Meals',
  'Appetizers',
  'Rizo',
  'Fries',
  'Sauces',
  'Combo',
  'Extras',
  'Drinks'
];

// Categories to exclude from the menu
export const EXCLUDED_CATEGORIES = /^(2nd Side|1st Side)$/i;

// ============================================================================
// Scroll Configuration
// ============================================================================

export const SCROLL_THRESHOLD = 800;
export const VISIBILITY_THRESHOLD = 200;
export const HEADING_OFFSET = 110;
export const DEBOUNCE_DELAY = 100;
export const CATEGORY_CHANGE_THROTTLE = 200;
export const SCROLL_TIMEOUT = 1500;
export const PROGRAMMATIC_SCROLL_DELAY = 1000;

// Mobile specific offsets
export const MOBILE_SCROLL_OFFSET = 120;
export const DESKTOP_SCROLL_OFFSET = 110;

// ============================================================================
// Performance Configuration
// ============================================================================

export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
export const IMAGE_LAZY_LOAD_MARGIN = '100px';
export const INTERSECTION_THRESHOLD = 0.1;

// ============================================================================
// API Configuration
// ============================================================================

export const API_ENDPOINT = '/api/graphql';
export const API_HEADERS = {
  'Content-Type': 'application/json'
};

// ============================================================================
// Store Status
// ============================================================================

export const STORE_STATUS = {
  BUSY: '0',
  OPEN: '1',
  CLOSED: '2'
};

// ============================================================================
// Product Filtering Rules
// ============================================================================

// ============================================================================
// UI Configuration
// ============================================================================

export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280
};

export const Z_INDEX = {
  POPUP: 100,
  STICKY_NAV: 85,
  SCROLL_BUTTON: 50
};

// ============================================================================
// Helper Functions
// ============================================================================

export const isMobile = () => window.innerWidth < BREAKPOINTS.MOBILE;
export const isTablet = () =>
  window.innerWidth >= BREAKPOINTS.MOBILE &&
  window.innerWidth < BREAKPOINTS.DESKTOP;
export const isDesktop = () => window.innerWidth >= BREAKPOINTS.DESKTOP;
